import React, {withRouter} from 'react';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';

// import {PORTFOLIOS} from '../../data/portfolios';
import * as PORTFOLIOS from './../../data/portfolios';
import {Calendar} from './../../oss/Calendar';
import {BigCalendar} from './../../oss/BigCalendar';
import {strftime} from './../../utils/time';
import PortfolioTableDisplay from './../reuse/portfolio_table';
import AdSense from './../reuse/common/adsense';
import { ResponsivePie } from '@nivo/pie';
import {SECTOR_COLOR} from './../constant';


function filterDividends(shares, input_dividends, year){
  return Object.keys(input_dividends)
    .filter(function(div_date){
      return new Date(parseInt(div_date)).getFullYear() === year; 
    })
    .reduce((obj, key) => {
      const curr_date = new Date(parseInt(key))
      if (shares > 0){
        obj.push({
          "date": strftime("%m/%d/%Y", curr_date),
          // "value": ((shares * price) * input_dividends[key]) / 100,
          "value": (shares) * input_dividends[key],
        });
      }
      return obj;
    }, []);
}

function add_dividends(dividends_per_symbol){

  const dividend_sum = Object.keys(dividends_per_symbol).reduce(function(outer_obj, symbol){
    const dividends_per_year = dividends_per_symbol[symbol];

    const dividend_obj = dividends_per_year.reduce((obj, div) => {
      if (obj[div['date']] === undefined){
        obj[div['date']] = {
          "value": div['value'],
          "details": [symbol + " - " + div['value'].toFixed(2)],
        }
      } else {
        obj[div['date']] = {
          "value": div['value'] + obj[div['date']]['value'],
          "details": [symbol + " - " + div['value'].toFixed(2)].concat(obj[div['date']]['details']),
        }
      }
      return obj;
    }, outer_obj);

    return dividend_obj;

  }, {})

  // const dividend_sum = dividends_per_year.reduce((obj, div) => {
  //   if (obj[div['date']] === undefined){
  //     obj[div['date']] = {
  //       "value": div['value'],
  //       "details": [div['value']],
  //     }
  //   } else {
  //     obj[div['date']] = {
  //       "value": div['value'] + obj[div['date']]['value'],
  //       "details": [div['value']].concat(obj[div['date']]['details']),
  //     }
  //   }
  //   return obj;
  // }, {});

  const dividend_formatted = Object.keys(dividend_sum).map(function(date, idx){
    const data = {
      "date": date,
      "value": dividend_sum[date]['value'],
      "details": dividend_sum[date]['details'],
    }
    return data;
  });

  return dividend_formatted;
}

function compare( a, b ) {
  if ( a.date < b.date ){return -1;}
  if ( a.date > b.date ){return 1;}
  return 0;
}

function generateCalander(earnings){

  const formatted_events = earnings.map(function(earning, idx){
    return {
      title: "Earnings: " + earning.symbol,
      start: earning.earnings_start_date,
      end: earning.earnings_end_date,
    }
  })

  return formatted_events;
}

export default class Component extends React.Component {

  constructor(props){
    super(props);

    const portfolio = PORTFOLIOS[this.props.portfolio_xid];
    const stocks = portfolio.stocks.filter(function(ticker_dict){return ticker_dict['ticker'].symbol !== undefined});
    
    this.state = {
      net_equity: 10000,
      portfolio_xid: this.props.portfolio_xid,
      portfolio: portfolio,
      stocks: stocks,
    }
  }

  componentDidMount(){
    this.updateDisplayData();
  }

  updateDisplayData(){
    const stocks = this.state.stocks;
    const net_equity = Math.max(parseInt(this.state.net_equity), 1);
    // const missing = portfolio.stocks.filter(function(ticker){return ticker.symbol === undefined});

    // let total_2022 = [];
    let total_2021 = [];
    let total_2020 = [];
    let total_2019 = [];
    let pie_map = {};

    // const total_weight = 100;
    const total_weight = stocks.reduce(function(sum, stock){return sum+stock['weight'] }, 0);
    var all_earnings = [];

    const _ = stocks.map(function(stock_dict, idx){

      const stock = stock_dict['ticker'];
      const symbol = stock['symbol'];
      const weight = stock_dict['weight'];
      const dividends = JSON.parse(stock['details_dividends']);

      const details_earnings = stock['details_earnings'];
      const earnings = JSON.parse((details_earnings === undefined)? '{}': details_earnings);

      // Object.keys(earnings).map(function(key, idx){
      const start_key = (earnings['Value'] === undefined)? '0': 'Value';
      const end_key = (earnings['Value'] === undefined)? '1': 'Value';
      const earnings_missing = Object.keys(earnings).length === 0;

      const custom_earning_obj = {
        symbol: symbol,
        earnings_start_date: (earnings_missing)? null: new Date(parseInt(earnings[start_key]['Earnings Date'])),
        earnings_end_date: (earnings_missing)? null: new Date(parseInt(earnings[end_key]['Earnings Date'])),
        // earnings: earnings,
        // earnings_start_date: earnings[start_key],
        // earnings_end_date: earnings[end_key],

      }
      all_earnings.push(custom_earning_obj);
      // })

      const sector = (stock['sector'])? stock['sector']: '';
      if (pie_map[sector] === undefined){pie_map[sector] = 0;}
      pie_map[sector] += 1;

      var symbol_shares = (stock_dict['shares'] === undefined)? ((net_equity * (weight/total_weight)) / stock.open): (stock_dict['shares']);
      // var symbol_shares = ((net_equity * (weight/total_weight)) / stock.open);
      // const symbol_price = stock.open;
      
      // const d_2022 = filterDividends(symbol_shares, dividends, 2022);
      const d_2021 = filterDividends(symbol_shares, dividends, 2021);
      const d_2020 = filterDividends(symbol_shares, dividends, 2020);
      const d_2019 = filterDividends(symbol_shares, dividends, 2019);

      // total_2022[symbol] = d_2022;
      total_2021[symbol] = d_2021;
      total_2020[symbol] = d_2020;
      total_2019[symbol] = d_2019;

      const data = {
        symbol: symbol, 
        // d_2022: d_2022,
        d_2021: d_2021, 
        d_2020: d_2020, 
        d_2019: d_2019,
      }
      return data;
    })

    const cal_events = generateCalander(all_earnings);
    
    // const data_2022 = add_dividends(total_2022).sort( compare );
    const data_2021 = add_dividends(total_2021).sort( compare );
    const data_2020 = add_dividends(total_2020).sort( compare );
    const data_2019 = add_dividends(total_2019).sort( compare );

    const pie_data = Object.keys(pie_map).map(function(sector, idx){
      const lbl = (sector === undefined | sector === '')? '-': sector;
      return {"id": lbl, "label": lbl, "value": pie_map[sector], "color": SECTOR_COLOR[sector]};
    })

    const state = this.state;
    state.dividend_data = {
      data_2021: data_2021,
      data_2020: data_2020,
      data_2019: data_2019,
    };
    state.pie_data = pie_data;
    state.cal_events = cal_events;
    this.setState(state)
  }

  onEquityChange(e){
    try {
      const new_val = e.target.value;
      const state = this.state;
      state.net_equity = new_val;
      this.setState(state);
    } catch (e){
      return;
    }
  }

  onShareChange(e){
    e.preventDefault();
    let stocks = this.state.stocks;
    const target_ticker = e.currentTarget.dataset.ticker;
    const new_share_count = e.target.value;

    var search_idx = -1;
    for(var idx = 0; idx<stocks.length; idx++){
        if (stocks[idx].ticker.symbol === target_ticker){
            search_idx = idx;
            idx = stocks.length;
        }
    }

    if (search_idx > -1){
        stocks[search_idx]['shares'] = new_share_count;
    }

    const state = this.state;
    state.stocks = stocks;
    this.setState(state);
    this.updateDisplayData();
  }


  render (){
    const is_mobile = window.innerWidth < 1200;
    
    const portfolio = this.state.portfolio;
    const stocks = this.state.stocks;
    const net_equity = Math.max(parseInt(this.state.net_equity), 1);
    // const missing = portfolio.stocks.filter(function(ticker){return ticker.symbol === undefined});
    const total_weight = stocks.reduce(function(sum, stock){return sum+stock['weight'] }, 0);

    const cal_events = this.state.cal_events;
    
    // const data_2022 = this.state.total_2022;
    if (this.state.dividend_data === undefined){
      return '';
    }
    
    const data_2021 = this.state.dividend_data['data_2021'];
    const data_2020 = this.state.dividend_data['data_2020'];
    const data_2019 = this.state.dividend_data['data_2019'];

    const pie_data = this.state.pie_data;
    
    let stats_data = {};
    stats_data['total_holdings'] = 0;
    stats_data['total_equity'] = 0;
    stats_data['total_annual_dividend'] = 0;

    stocks.map(function(ticker_dict, idx){
      const ticker = ticker_dict['ticker'];
      const avg_price = (ticker.open? (ticker.open.toFixed(2)): ticker.open);
      
      var equity = (ticker_dict['shares'] === undefined)? (parseInt((ticker_dict['weight'] / total_weight) * net_equity)): (ticker_dict['shares']*avg_price);
      stats_data['total_equity'] += equity;

      const annual_dividend = ((ticker.open*ticker.dividendRate)/100) * (equity/ticker.open);
      stats_data['total_annual_dividend'] += annual_dividend;
      stats_data['total_holdings'] += 1;
    })

    return (
      <section id="portfolio" className="content-section py-5 my-5">
        
        <div className="row">
          {/* <div className={(is_mobile)? '': "col-1"}></div> */}
          <div className={(is_mobile)? "col-12 m-0 p-0": "col-10"}>
            <div className="mx-1">
              
              <h3 className="text-center">{portfolio.title}</h3>

              <p className="mt-5">{portfolio.description}</p>
              <a href={portfolio.source} className="">Source inspiration</a>
              <hr className=""/>

              {/* <div className="my-5 text-black">
                <label className="col-form-label col-form-label-lg" >Investment amount (in USD): </label>
                <input type="text" className="form-control form-control-lg" value={this.state.net_equity} onChange={this.onEquityChange.bind(this)} />
              </div> */}

              <div className="row">

                <div className="col-md-6 p-0 pr-1">
                  <div className="my-5">
                    <div className="rounded border p-2">
                      <h4 className="p-2">Stats</h4>
                      <table className="table table-hover">
                        <tbody>
                          <tr className="text-size-5">
                            <th scope="row">Portfolio net</th>
                            <td><NumberFormat value={stats_data['total_equity']} fixedDecimalScale decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                          </tr>
                          <tr className="text-size-3">
                            <th scope="row">Holdings</th>
                            <td>{stats_data['total_holdings']}</td>
                          </tr>
                          <tr className="text-size-3">
                            <th scope="row">Estimated dividend earnings (this year)</th>
                            <td><NumberFormat value={stats_data['total_annual_dividend']} fixedDecimalScale decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                          </tr>
                          <tr className="text-size-3">
                            <th scope="row">Estimated dividend yeild % (this year)</th>
                            <td><NumberFormat value={(stats_data['total_annual_dividend'] / stats_data['total_equity']) * 100} fixedDecimalScale decimalScale={2} displayType={'text'} suffix={'%'} /></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 p-0 pl-1">
                  <div className="my-5">
                    <div className="rounded border p-2">
                    <h4 className="p-2">Sectors</h4>
                      <div className="" style={{ height: 300 }}>
                        <MyResponsivePie data={pie_data}/>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* {(is_mobile)? (<div className="my-3"><AdSense mode="h"/></div>): ''} */}

              <div className="my-5">
                <div className="rounded border p-2">
                  <h4 className="p-2">Portfolio</h4>
                  {/* <PortfolioTableDisplay net_equity={net_equity} stocks={stocks} editable={true} /> */}
                  {/* <hr className="my-3"/> */}
                  <PortfolioTableDisplay net_equity={net_equity} stocks={stocks} onShareChange={this.onShareChange.bind(this)}/>
                </div>
              </div>

              <div className="my-3"><AdSense mode="h"/></div>

              <div className="my-5">

                <div className="rounded border p-2">
                  <h4 className="">Dividends</h4>

                  <div className="mt-5">
                    <h3 className="my-3">2021</h3>
                    <div className="column-scroll">
                      <Calendar data={data_2021} year={"2021"} color="#fd4c7a" theme={"light"} />
                    </div>
                  </div>

                  <div className="mt-5">
                    <h3 className="my-3">2020</h3>
                    <div className="column-scroll">
                      <Calendar data={data_2020} year={"2020"} color="#8dd3c7" theme={"light"} />
                    </div>
                  </div>
                </div>

              </div>

              <div className="my-3"><AdSense mode="h"/></div>

              <div className="my-5">
                <div className="rounded border p-2">
                  <h4 className="p-2">Earnings report</h4>
                  <div className="" style={{ height: "700px" }}>
                    <BigCalendar events={cal_events} />
                  </div>
                </div>
              </div>

            </div>
          </div>

          {(is_mobile)? '': (
            <div className={"col-2  my-5 py-5"}>
              <div className="border rounded py-5">
                <div className="mb-5"><AdSense /></div>
                {/* <div className="mb-5"><AdSense /></div> */}
              </div>
            </div>
          )}

        </div>

        
        <div className="text-center">
          <Link  to="/signup" className="btn btn-lg btn-success">
            Customize this portfolio!
          </Link>
        </div>

        <hr className=""/>

      </section>
    )
  }
}


function MyResponsivePie(props){
  const data = props.data;
  const colors = data.map(function(item, idx){return item['color']});
  return (
    <ResponsivePie
        data={data}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        // colors={{ scheme: 'nivo' }}
        colors={colors}
        borderWidth={1}
        borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextXOffset={6}
        radialLabelsTextColor="#333333"
        radialLabelsLinkOffset={0}
        radialLabelsLinkDiagonalLength={16}
        radialLabelsLinkHorizontalLength={24}
        radialLabelsLinkStrokeWidth={1}
        radialLabelsLinkColor={{ from: 'color' }}
        slicesLabelsSkipAngle={10}
        slicesLabelsTextColor="#333333"
        animate={true}
        motionStiffness={90}
        motionDamping={15}
    />
  )
}
